module.exports = __webpack_public_path__ + "img/tx1.b392f9fb.png";